module.exports = __webpack_public_path__ + "img/settings-1_1920.b6a949e9.jpg";